module.exports = __webpack_public_path__ + "static/img/ikona_cw6-OFF.33e126b5.png";